import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { DriverService } from '../../../core/services/driver.service';
import { Pagination } from '../../../core/dto/pagination';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as moment from 'moment';

@Component({
  selector: 'app-view-drivers',
  templateUrl: './view-drivers.component.html',
  styleUrls: ['./view-drivers.component.scss'],
})
export class ViewDriversComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Drivers',
      icon: 'team',
    },
  ];
  driversData: any[] = [];

  searchText: any;
  driverStatus = true;
  dateRanges: any[] = [];
  startTime: any;
  endTime: any;

  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  isDeleting = false;

  skeletonTableColumns: any[] = [
    'Driver ID',
    'Driver Segment',
    'Supplier Name',
    'Supplier Contact No',
    'Driver Name',
    'Driver Contact No',
    'Driver Availability',
    'Last Transfer Date and Time',
    'Last Transfer Completion Time',
    'Next Transfer Allocated Date and Time',
    'Created Date',
    'Actions',
  ];
  loading = false;
  driverAvailabilityStatus = SETTINGS.DRIVER_AVAILABILITY_STATUS;

  constructor(
    private driversService: DriverService,
    private router: Router,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {}

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedDriver();
  }

  getPagedDriver(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchText: this.searchText,
        status: this.driverStatus,
        startTime: this.startTime,
        endTime: this.endTime,
        currentStartDate: new Date().toISOString(),
      },
    });
    this.driversService.getPagedDrivers(payload).then((res: any) => {
      this.loading = false;
      this.driversData = res[0].data;
      this.pageSize.length = res[0].metadata[0]?.total;
    });
  }

  activeFilter(): void {
    this.driverStatus = !this.driverStatus;
    this.getPagedDriver();
  }

  goto(id?: any, type?: string): void {
    if (type === 'single-view') {
      this.router.navigate([`/admin/drivers/${id}`]);
    } else if (type === 'edit') {
      this.router.navigate([`/admin/drivers/add-edit/${id}`]);
    } else {
      this.router.navigate(['/admin/drivers/add-edit']);
    }
  }

  async softDeleteConfirm(id: any): Promise<void> {
    this.isDeleting = true;
    try {
      await this.driversService.softDeleteDriver(id);
      this.isDeleting = false;
      this.message.success('Driver has been deleted!');
      this.getPagedDriver();
    } catch (e) {
      this.isDeleting = false;
    }
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedDriver();
  }

  search(): void {
    this.startTime = null;
    this.endTime = null;
    if (this.dateRanges[0] && this.dateRanges[1]) {
      this.startTime = moment(this.dateRanges[0]).startOf('days');
      this.endTime = moment(this.dateRanges[1]).endOf('days');
    }
    this.getPagedDriver();
  }

  resetSearch(): void {
    this.searchText = null;
    this.dateRanges = [];
    this.startTime = '';
    this.endTime = '';
    // this.driverStatus = null;
    this.getPagedDriver();
  }

  changeStatus(id: any, status: boolean): void {
    this.driversService
      .updateDriver({ _id: id, active: !status })
      .subscribe((res) => {
        this.message.success(
          status
            ? 'Driver has been deactivated!'
            : 'Driver has been activated!',
        );
        this.getPagedDriver();
      });
  }

  hasAccessToPerformAction(type: string): boolean {
    if (type === 'update_delete') {
      return (
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'DRIVER_UPDATE',
        ) ||
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'DRIVER_DELETE',
        )
      );
    } else if (type === 'all') {
      return (
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'DRIVER_UPDATE',
        ) ||
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'DRIVER_DELETE',
        ) ||
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'DRIVER_SINGLE_VIEW',
        )
      );
    } else {
      return true;
    }
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  checkPermissionsWithUserActiveStatus(data: any, permission: string): boolean {
    return (
      _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), permission) &&
      data.active
    );
  }

  getTransferBookingsData(data: any, type: string): string {
    let dateString = '';
    switch (type) {
      case 'last':
        if (
          data?.lastArrivalTransferBooking ||
          data?.lastDepartureTransferBooking
        ) {
          if (
            data?.lastArrivalTransferBooking &&
            data?.lastDepartureTransferBooking
          ) {
            dateString =
              moment(
                data?.lastArrivalTransferBooking?.tourDetails?.pickUpTime,
              ) >
              moment(
                data?.lastDepartureTransferBooking?.tourDetails
                  ?.departureTourDetails?.departurePickUpTime,
              )
                ? moment(
                    data?.lastArrivalTransferBooking?.tourDetails?.pickUpTime,
                  ).format('DD-MM-YYYY | hh:mm:a')
                : moment(
                    data?.lastDepartureTransferBooking?.tourDetails
                      ?.departureTourDetails?.departurePickUpTime,
                  ).format('DD-MM-YYYY | hh:mm:a');
          } else if (!data?.lastArrivalTransferBooking) {
            dateString = moment(
              data?.lastDepartureTransferBooking?.tourDetails
                ?.departureTourDetails?.departurePickUpTime,
            ).format('DD-MM-YYYY | hh:mm:a');
          } else if (!data?.lastDepartureTransferBooking) {
            dateString = moment(
              data?.lastArrivalTransferBooking?.tourDetails?.pickUpTime,
            ).format('DD-MM-YYYY | hh:mm:a');
          }
        } else {
          dateString = '-';
        }
        return dateString;
      case 'last-time':
        if (
          data?.lastArrivalTransferBooking ||
          data?.lastDepartureTransferBooking
        ) {
          if (
            data?.lastArrivalTransferBooking &&
            data?.lastDepartureTransferBooking
          ) {
            dateString =
              moment(
                data?.lastArrivalTransferBooking?.tourDetails?.pickUpTime,
              ) >
              moment(
                data?.lastDepartureTransferBooking?.tourDetails
                  ?.departureTourDetails?.departurePickUpTime,
              )
                ? moment(
                    data?.lastArrivalTransferBooking?.tourDetails?.pickUpTime,
                  ).format('hh:mm:a')
                : moment(
                    data?.lastDepartureTransferBooking?.tourDetails
                      ?.departureTourDetails?.departurePickUpTime,
                  ).format('hh:mm:a');
          } else if (!data?.lastArrivalTransferBooking) {
            dateString = moment(
              data?.lastDepartureTransferBooking?.tourDetails
                ?.departureTourDetails?.departurePickUpTime,
            ).format('hh:mm:a');
          } else if (!data?.lastDepartureTransferBooking) {
            dateString = moment(
              data?.lastArrivalTransferBooking?.tourDetails?.pickUpTime,
            ).format('hh:mm:a');
          }
        } else {
          dateString = '-';
        }
        return dateString;
      case 'next':
        if (
          data?.nextArrivalTransferBooking ||
          data?.nextDepartureTransferBooking
        ) {
          if (
            data?.nextArrivalTransferBooking &&
            data?.nextDepartureTransferBooking
          ) {
            dateString =
              moment(
                data?.nextArrivalTransferBooking?.tourDetails?.pickUpTime,
              ) <
              moment(
                data?.nextDepartureTransferBooking?.tourDetails
                  ?.departureTourDetails?.departurePickUpTime,
              )
                ? moment(
                    data?.nextArrivalTransferBooking?.tourDetails?.pickUpTime,
                  ).format('DD-MM-YYYY | hh:mm:a')
                : moment(
                    data?.nextDepartureTransferBooking?.tourDetails
                      ?.departureTourDetails?.departurePickUpTime,
                  ).format('DD-MM-YYYY | hh:mm:a');
          } else if (!data?.nextArrivalTransferBooking) {
            dateString = moment(
              data?.nextDepartureTransferBooking?.tourDetails
                ?.departureTourDetails?.departurePickUpTime,
            ).format('DD-MM-YYYY | hh:mm:a');
          } else if (!data?.nextDepartureTransferBooking) {
            dateString = moment(
              data?.nextArrivalTransferBooking?.tourDetails?.pickUpTime,
            ).format('DD-MM-YYYY | hh:mm:a');
          }
        } else {
          dateString = '-';
        }
        return dateString;
      default:
        return '-';
    }
  }

  handleCancelSelectStatus(): void {}

  handleOkSelectStatus(data: any): void {
    this.loading = true;
    this.driversService
      .updateDriver({ _id: data._id, active: !data.active })
      .subscribe((res) => {
        this.message.success(
          data.active
            ? 'Driver has been deactivated!'
            : 'Driver has been activated!',
        );
        this.getPagedDriver();
      });
  }
}
